import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityInterface, And, WorkflowStepInterface } from '@vendasta/automata';
import { Observable } from 'rxjs';
import { ActivityTableEntry, AutomationDisplayService, NodeData } from '../../common/automation-display.service';
import { OrderExpiryLabelMap } from './sales-order-expiring-panel/sales-order-expiring-panel.component';

@Injectable({ providedIn: 'root' })
export class SalesOrderExpiringService extends AutomationDisplayService {
  constructor(protected readonly translateService: TranslateService) {
    super();
  }

  getActionSubtitle(_namespace: string, step: WorkflowStepInterface): Observable<string> {
    const and = And.fromRuleInterface(step.choices.rules[0]);
    const orderExpiry = and.value[0]?.value as string;
    const expiry = this.translateService.instant(OrderExpiryLabelMap[orderExpiry]);
    return this.translateService.stream('AUTOMATIONS.EDITOR.TRIGGERS.SALES_ORDER_EXPIRING.ACTION.WHEN_STATUS_CHANGES', {
      expiry,
    });
  }

  getAutomationNodeData(
    _namespace: string,
    _step: WorkflowStepInterface,
    _isWaitUntilNode: boolean,
  ): Observable<NodeData> {
    // Node display data contains the text to display as well as validation errors.
    // Validation errors appear when the node is rendered.
    return this.nodeDisplayData(
      this.translateService.instant('AUTOMATIONS.EDITOR.TRIGGERS.SALES_ORDER_EXPIRING.WHEN_ACTION'),
      this.noValidationErrorsDetected(),
    );
  }

  /**
   * This is the text that appears in the activity column in the activity table.
   * Each column has a title (big text) and body (small text).
   * Most, but not all, trigger activity entries have "Entered the automation" (or similar) as the title
   * and then a custom body.
   */
  getActivityColumn(_namespace: string, _activity: ActivityInterface): ActivityTableEntry {
    // A convenience method that provides a table entry with the standard trigger title.
    return this.triggerActivityEntry(
      this.translateService.instant('AUTOMATIONS.EDITOR.TRIGGERS.SALES_ORDER_EXPIRING.ACTIVITY'),
    );
  }
}
